import React from 'react';

// Redrawn from the 1 Oct approved design (Toma, 29 Oct). Both take their colour from the text
// around them through currentColor: white on the Reactivate button, accent on the Dashboard item.
type IconProps = React.SVGProps<SVGSVGElement>;

const ExpiredArrowIcon: React.FC<IconProps> = (props) => (
  <svg width={24} height={24} viewBox={'0 0 24 24'} fill={'none'} aria-hidden {...props}>
    <path
      d={'M4 12h15.5M14 6.5 19.5 12 14 17.5'}
      stroke={'currentColor'}
      strokeWidth={1.9}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
  </svg>
);

const ExpiredHouseIcon: React.FC<IconProps> = (props) => (
  <svg width={24} height={24} viewBox={'0 0 24 24'} fill={'none'} aria-hidden {...props}>
    <path
      d={'M2.6 11.2 12 3.2l9.4 8'}
      stroke={'currentColor'}
      strokeWidth={2}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
    <path
      d={'M5 9.6v11.2h14V9.6'}
      stroke={'currentColor'}
      strokeWidth={2}
      strokeLinecap={'round'}
      strokeLinejoin={'round'}
    />
  </svg>
);

export { ExpiredArrowIcon, ExpiredHouseIcon };
